import React from "react";
import { TelemetryContext } from "providers/TelemetryContext";
import { LogEvent } from "util/Tele";

export const useTelemetry = (): (name: string, properties?: any, debug?: any, categoryOverride?: string) => void => {
    const telemetryCategory = React.useContext(TelemetryContext);
    // @ts-ignore
    return (name: string, properties?: any, debug?: any, categoryOverride?: string) => LogEvent(name, properties, debug, categoryOverride || telemetryCategory);
}